import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import CO2Service from '~/api/services/co2'
import Layout from '~/components/Layout'
import { handleErrors } from '~/utils/helpers'
import { El } from '~/components/Layout/style'
import { FormProvider, useForm } from 'react-hook-form'
import notify from '~/components/Notify'
import { useAuth } from '~/routes/components/AuthProvider'
import { Tab } from 'semantic-ui-react'
import MemoryForm from './Tabs/MemoryForm'
import General from './Tabs/General'

const Co2: React.FC = () => {
  const { t } = useTranslation()
  const { systemData: { languages } } = useAuth()

  const methods = useForm({
    mode: 'onSubmit'
  })

  const [isBusy, setIsBusy] = useState(false)
  const [activeTabIndex, setActiveTabIndex] = useState<string | number>(0)
  const [startingColVal, setStartingColVal] = useState({
    yourValueColor: '',
    bayernValueColor: ''
  })

  useEffect(() => {
    fetchCO2Settings()
  }, [])

  async function fetchCO2Settings(): Promise<void> {
    setIsBusy(true)
    try {
      const response = await CO2Service.getCo2Settings()
      if (response.data?.texts) {
        languages.map(language => {
          if (!response.data.texts[0]?.languages.find(lang => lang.id === language.id)) {
            response.data.texts[0].languages.push({
              id: language.id,
              translation: '',
              label: language.label
            })
          }
        })
      }
      setStartingColVal({
        yourValueColor: response.data.yourValueColor,
        bayernValueColor: response.data.bayernValueColor
      })
      methods.reset({
        ...response.data,
        perimeters: response.data.perimeters.map(perimeter => ({ perimeter })),
        memoryFields: response.data?.memoryFields?.map(field => ({ slug: field }))
      })
    } catch (error) {
      handleErrors(error)
    }
    setIsBusy(false)
  }

  function renderActions() {
    return <El.PageHeaderActionButton
      content={t('Update')}
    />
  }

  async function onSubmit(data) {
    setIsBusy(true);
    data.perimeters = data.perimeters.map(item => item.perimeter)
    try {
      await CO2Service.updateCo2Settings({
        ...data,
        memoryFields: data?.memoryFields?.map(memoryField => memoryField?.slug)
      })
      setStartingColVal({
        yourValueColor: data.yourValueColor,
        bayernValueColor: data.bayernValueColor
      })
      notify(t('Successfully update CO2 Klima Check settings'), 'success')
    } catch (error) {
      handleErrors(error)
    }
    setIsBusy(false);
  }

  function renderPanes() {
    const panes = [
      {
        menuItem: t('General'),
        render: () => <General startingColVal={startingColVal} />
      },
      {
        menuItem: t('Memory'),
        render: () => <MemoryForm />
      }
    ]

    return (
      <Tab
        menu={{ secondary: true, pointing: true }}
        activeIndex={activeTabIndex}
        panes={panes}
        onTabChange={(_, data) => setActiveTabIndex(data.activeIndex as number)}
      />
    );
  }

  return <Layout
    title={<span dangerouslySetInnerHTML={{ __html: t('CO2 Klima Check') }} />}
    segmented
    isBusy={isBusy}
    actions={renderActions()}
    onSubmit={methods.handleSubmit(onSubmit)}
  >
    <FormProvider {...methods}>
      {renderPanes()}
    </FormProvider>
  </Layout>
}
export default Co2